package com.hyperether.goodjob.database

import app.cash.sqldelight.async.coroutines.awaitAsList
import app.cash.sqldelight.coroutines.asFlow
import app.cash.sqldelight.coroutines.mapToList
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.flow.Flow

class SkillsDaoImpl(private val sharedDatabase: SharedDatabase) : SkillsDao {
    override suspend fun insertSkill(skill: com.hyperether.goodjob.models.Skills) {
        sharedDatabase { database ->
            database.appDatabaseQueries.transaction {
                database.appDatabaseQueries.insertSkill(
                    _id = skill._id,
                    name = skill.name,
                    workspaceId = skill.workspaceId
                )
            }
        }
    }

    override suspend fun updateSkillById(skill: com.hyperether.goodjob.models.Skills) {
        sharedDatabase { database ->
            database.appDatabaseQueries.transaction {
                database.appDatabaseQueries.updateSkillById(
                    id = skill._id,
                    name = skill.name,
                    workspaceId = skill.workspaceId
                )
            }
        }
    }

    override suspend fun getSkillsFlow(workspaceId: String): Flow<List<Skills>> {
        return sharedDatabase { database ->
            database.appDatabaseQueries
                .getSkillsByWorkspaceId(workspaceId)
                .asFlow()
                .mapToList(Dispatchers.Default)
        }
    }

    override suspend fun getSkills(workspaceId: String): List<Skills> =
        sharedDatabase { database ->
            database.appDatabaseQueries.getSkillsByWorkspaceId(workspaceId).awaitAsList()
        }

    override suspend fun deleteAllSkills() {
        sharedDatabase { database ->
            database.appDatabaseQueries.deleteAllSkills()
        }
    }

    override suspend fun deleteById(id: String) {
        sharedDatabase { database ->
            database.appDatabaseQueries.deleteSkillById(id)
        }
    }
}